module.exports = __webpack_public_path__ + "img/TJM_8850f7b.webp";